import React from 'react';
import { Typography } from '@lamimed/pantheon';

import * as S from './styles';

const Notification: React.FC = () => {
  return (
    <S.Wrapper>
      <Typography>
        In caso di cancellazione, il pagamento sarà rimborsato integralmente
      </Typography>
    </S.Wrapper>
  );
};

export default Notification;
